import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/styles/main.css'

// 导入全局错误处理
import { setupGlobalErrorHandlers } from './utils/errorHandler'
import { debugWarn } from './utils/env'

// 注册 Service Worker
if ('serviceWorker' in navigator) {
  import('./registerSW').then(({ registerSW }) => {
    registerSW()
  }).catch((error) => {
    debugWarn('Service Worker 注册失败:', error)
  })
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// 设置全局错误处理
setupGlobalErrorHandlers()

app.mount('#app')